import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import appStore from "store/index";

import App from "./App";
import "./index.scss";

const AppContainer = () => {
  return (
      <Provider store={appStore}>
        <Router>
          <App />
        </Router>
      </Provider>
  );
};

ReactDOM.render(
  <React.StrictMode>
    <AppContainer />
  </React.StrictMode>,
  document.getElementById("root")
);
